import { BaseController } from '@maia/feature-utils';
import { TeamService, TeamDto } from '@maia/shared';

export class TeamController extends BaseController {
  constructor(private TeamService: TeamService) {
    super();
  }

  async findMany(search: Record<string, unknown>) {
    const response = await this.getEntities(
      this.TeamService,
      { path: '', search },
      TeamDto,
    );

    return response;
  }

  async find(guid: string) {
    const response = await this.getEntity(this.TeamService, guid, TeamDto);
    return response;
  }
}
